import {
  Http,
  Auth,
  Url,
  Storage,
} from '@intelipost-js/secure-providers';
import { ScToast } from '@intelipost-js/secure-components';

export default {
  getCompany({ commit, dispatch }) {
    const { client_id } = Auth.getUser();

    commit('toggleLoading', true);
    return Promise.all([
      Http.get(Url.toQueryString('api/v1/client', null, [client_id])),
      dispatch('getCompanyLogo'),
    ])
      .then(([res = {}]) => {
        const { data = {} } = res;
        const { content = {} } = data;
        const { company_security = {} } = content;
        let fmtCompanySecurity;

        commit('toggleLoading', false);
        if (!company_security.password_rules) {
          fmtCompanySecurity = Object.assign(company_security, { password_rules: [] });
          commit('setCompany', Object.assign(content, { company_security: fmtCompanySecurity }));
        }
        commit('setCompany', content);
      })
      .catch(() => {
        commit('toggleLoading', false);
      });
  },
  getCompanyLogo({ commit, dispatch }) {
    commit('toggleLoading', true);
    return Http.get('api/v1/client/logo')
      .then((res) => {
        const url = res.data.content;

        if (url) {
          return dispatch('getBlobImage', url)
            .then((file) => {
              commit('setCompanyLogo', file);
              commit('toggleLoading', false);
            });
        }
        commit('toggleLoading', false);
        return res;
      })
      .catch(() => {
        commit('toggleLoading', false);
      });
  },
  getBlobImage({ commit }, url) {
    return Http.request({
      url,
      responseType: 'blob',
      headers: {
        'Cache-Control': 'no-cache',
      },
    })
      .then((res) => {
        const fileUrl = url.split('?')[0].split('/');
        const fileName = fileUrl[fileUrl.length - 1];
        return Promise.resolve({
          source: new File([res.data], fileName, { type: 'image/png' }),
          options: {
            type: 'limbo',
          },
        });
      });
  },
  saveCompany({ commit }, company) {
    commit('toggleLoading', true);
    return Http.put('api/v1/client', company)
      .then(() => {
        commit('toggleLoading', false);
        const client = Storage.get('client');
        const {
          weight_unit,
          dimension_unit,
        } = company;
        Storage.set('client', Object.assign(client, { weight_unit, dimension_unit }));
        ScToast.success('Dados atualizados com sucesso');
      }).catch(() => {
        commit('toggleLoading', false);
      });
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/company/store/actions.js